import { api } from "../../api"

export async function loadSites(): Promise<Site[]> {
    let site = await api<Site[]>("content", {})
    return site.data
}
